import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Chiedi from "@/pages/Chiedi";
import Catalogo from "@/pages/Catalogo";
import RecipeDetail from "@/pages/RecipeDetail";
import JobsList from "@/pages/JobsList";
import JobDetail from "@/pages/JobDetail";
import Admin from "@/pages/Admin";
import Impostazioni from "@/pages/Impostazioni";
import Soluzioni from "@/pages/Soluzioni";
import SoluzioneDetail from "@/pages/SoluzioneDetail";
import DeploymentDetail from "@/pages/DeploymentDetail";
import Costruisci from "@/pages/Costruisci";
import CostruisciApp from "@/pages/CostruisciApp";
import CostruisciList from "@/pages/CostruisciList";
import Settori from "@/pages/Settori";
import Componi from "@/pages/Componi";
import ComponiApp from "@/pages/ComponiApp";

const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="adr-skeleton w-32 h-8" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
};

const AdminRoute = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/chiedi" replace />;
  return <Admin />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<Navigate to="/chiedi" replace />} />
            <Route path="/chiedi" element={<Chiedi />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/catalogo/:slug" element={<RecipeDetail />} />
            <Route path="/lavori" element={<JobsList />} />
            <Route path="/lavori/:id" element={<JobDetail />} />
            <Route path="/soluzioni" element={<Soluzioni />} />
            <Route path="/soluzioni/deployment/:id" element={<DeploymentDetail />} />
            <Route path="/soluzioni/:slug" element={<SoluzioneDetail />} />
            <Route path="/costruisci" element={<Costruisci />} />
            <Route path="/costruisci/le-mie" element={<CostruisciList />} />
            <Route path="/costruisci/:id" element={<CostruisciApp />} />
            <Route path="/settori" element={<Settori />} />
            <Route path="/componi" element={<Componi />} />
            <Route path="/componi/:id" element={<ComponiApp />} />
            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/impostazioni" element={<Impostazioni />} />
            <Route path="*" element={<Navigate to="/chiedi" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
